<ng-container *ngIf="!task; else tenderDef">
  <!-- anyadir misma estructura de baseTask.template-->
  <div class="wrapper wrapper-content ng-scope animated fadeInRight">
    <dossierHeader *ngIf="project && task" [projectId]="project.identifier"
      [title]="translateService.instant('TenderDefinition.title')" [titleIcon]="'fa fa-tasks'">
    </dossierHeader>
    <div class="container-fluid  p-0">
      <ng-container *ngIf="isModel">
        <div class="alert alert-info" role="alert">
          <span style="line-height: 2em;"><i class="fa fa-1-5x fa-info-circle mr-5" aria-hidden="true"></i>{{
            'ProcurementProject.models.info' | translate }}</span>
        </div>
      </ng-container>
      <ng-container *ngTemplateOutlet="tenderDef"></ng-container>
    </div>
  </div>
</ng-container>
<ng-template #tenderDef>
  <div class="container-fluid ">
    <div class="row" *ngIf="project">
      <div class="col-12">
        <p-tabView>
          <p-tabPanel cache="false" header="{{ 'TenderEvaluationCommittee.title' | translate }}"
            [selected]="VIEW_VALUES.OA === view" *ngIf="isViewActive(VIEW_VALUES.OA)">
            <ng-template pTemplate="content">
              <tenderingCommittes [project]="project" [data]="this.tenderEvaluationCommittees" [task]="task"
                [tenderingPhases]="this.tenderingPhases" (updated)="this.fireTenderingCommitteChange($event)"
                (editDialogOpened)="setEditDialogOpened($event)"></tenderingCommittes>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel cache="false" header="{{ 'Envelope.title' | translate }}"
            [selected]="VIEW_VALUES.ENVELOPE === view" *ngIf="isViewActive(VIEW_VALUES.ENVELOPE)">
            <ng-template pTemplate="content">
              <ng-container *ngIf="this.tenderingEnvelopes !== undefined">
                <tenderingEnvelopes [project]="project" [data]="this.tenderingEnvelopes"
                  [validations]="this.envelopeValidations" [tenderingPhases]="this.tenderingPhases"
                  (updated)="this.fireEnvelopeChange($event)" (editDialogOpened)="setEditDialogOpened($event)"
                  (orderModified)=updateAllEnvelopeOrder($event)>
                </tenderingEnvelopes>
              </ng-container>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel cache="false" header="{{ 'TenderingPhase.title' | translate }}"
            [selected]="VIEW_VALUES.PHASE === view" *ngIf="isViewActive(VIEW_VALUES.PHASE)">
            <ng-template pTemplate="content">
              <ng-container *ngIf="this.tenderingPhases !== undefined">
                <tenderingPhases [project]="project" [tenderEvaluationCommittees]="this.tenderEvaluationCommittees"
                  [tenderingEnvelopes]="this.tenderingEnvelopes" [data]="this.tenderingPhases"
                  [validations]="this.tenderingPhasesValidations" (updated)="this.fireTenderingPhaseChange($event)"
                  (editDialogOpened)="setEditDialogOpened($event)"
                  (deletedCommitee)="updateEnvelopeCommitteeRef($event)" (dispatch)="dispatchTask()">
                </tenderingPhases>
              </ng-container>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel cache="false" header="{{ 'AwardCriteria.title' | translate }}"
            [selected]="VIEW_VALUES.CRITERIA === view" *ngIf="isViewActive(VIEW_VALUES.CRITERIA)">
            <ng-template pTemplate="content">
              <tenderingAwardCriteria [project]="project" (editDialogOpened)="setEditDialogOpened($event)">
              </tenderingAwardCriteria>
            </ng-template>
          </p-tabPanel>
        </p-tabView>
      </div>
    </div>
  </div>
</ng-template>

<p-dialog header="Seleccionar modelo" [(visible)]="tenderModelsPopupVisible" [responsive]="false" showEffect="fade"
  [modal]="true" (onHide)="onCloseTenderDefModel()" [resizable]="false" [closable]="true" [dismissableMask]="true"
  [closeOnEscape]="false" [blockScroll]="true" [style]="{'width':'60vw'}"
  [contentStyle]="{ 'max-height': '80vh', overflow: 'hidden'}">
  <sub-header [isModal]="true" [includeContextHelp]="true" *ngIf="tenderModelsPopupVisible">
  </sub-header>
  <p-scrollPanel [style]="{width: '100%', height: '50vh'}" styleClass="custombar1" *ngIf="tenderModelsPopupVisible">
    <div class="wrapper wrapper-content">
      <div class="container-fluid">
        <div class="row">
          <div class=" alert alert-info col-12" role="alert">
            <i class="fas fa-lg fa-info-circle m-r-lg"></i> {{ 'TenderDefinition.selectmodel' |
            translate }}
          </div>
        </div>
        <div class="row">
          <p-checkbox binary="true" label="{{ 'TenderDefinition.filtermodeltenderdef' | translate }}"
            [(ngModel)]="modelsTenderDefMOD_LIC" (ngModelChange)="loadModelsTenderDef()" class="btn btn-filter">
          </p-checkbox>
        </div>

        <div class="row">
          <div class="col-12  m-t-lg" *ngIf="models && models.length > 0">
            <p-table [value]="models" sortField="name" sortOrder="1" [rows]="20" [paginator]="false" [pageLinks]="4"
              [rowsPerPageOptions]="[15, 30, 100]"
              class="footer-over-pagination  mb-3 table table-striped table-hover ">
              <ng-template pTemplate="header">
                <tr class="ui-widget-header m-t-md">
                  <th class="p-md">
                    <strong> {{ 'ProcurementProject.models.selectTHeader' | translate }}</strong>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-model>
                <tr>
                  <td>
                    <span style="line-height: 2em;"><i class="fa fa-clone fa-lg m-r-lg"></i>{{
                      model.contractFolderId }} {{ model.abbreviatedTitle }}</span> <button
                      class="btn btn-sm btn-primary t-action-button float-right" aria-expanded="false"
                      (click)="createTenderDefFromModel(model)">
                      <i class="fas fa-plus" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </p-scrollPanel>
</p-dialog>